import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { Network, networksArray } from "@/interfaces/network";
import { FungibleTokenContract } from "@/services/contracts/near/FungibleToken";
import { createObjectFromKeys } from "@/utils";

export type Tokens = Record<string, FungibleTokenContract>;

interface Store {
  tokens: Record<Network, Tokens>;
  getTokenById: (network: Network, tokenId: string) => FungibleTokenContract | null;
  setTokens: (network: Network, tokens: Record<string, FungibleTokenContract>) => void;
}

export const useTokens = create<Store>()(
  immer((set, get) => ({
    tokens: createObjectFromKeys(networksArray, {} as Tokens),
    getTokenById: (network, tokenId: string) => {
      const tokens = get().tokens[network];
      return tokens[tokenId] || null;
    },
    setTokens: (network, tokens) =>
      set((state) => {
        state.tokens = { ...state.tokens, [network]: tokens };
      }),
  })),
);
